import { createSelector } from 'reselect';

// Types
import { RootState } from 'types/RootState.types';

// Config
import featureConstants from '@constants/featureConstants';
import { isFeatureActive } from '@redux/reducers/config/configReducer';
import {
  getEditBasketItemOutOfStockOverlayIdsSelector,
  getEditBasketItemRemoveOverlayIdsSelector,
  getEditBasketItemUpdateActiveIdsSelector,
  getEditBasketRemoveItemApiCallActiveIdsSelector,
  getIsProcessingOrderFormApiSelector,
  getOrderFormItemsSelector,
  getTradeInQuotesSelector,
} from '@redux/reducers/order-form/orderFormSelector';
import { getPartnerDiscountEnabledSelector } from '@redux/reducers/user/userSelector';
import { shouldShowThresholdBar } from '@utils/orderform/shouldShowThresholdBar';

const getFixedBasketFooterFeatureActive = (state: RootState) =>
  isFeatureActive(state, featureConstants.FIXED_BASKET_FOOTER);

const editBasketModalState = createSelector(
  [
    getEditBasketItemOutOfStockOverlayIdsSelector,
    getEditBasketItemRemoveOverlayIdsSelector,
    getEditBasketItemUpdateActiveIdsSelector,
    getEditBasketRemoveItemApiCallActiveIdsSelector,
    getTradeInQuotesSelector,
    getIsProcessingOrderFormApiSelector,
    getOrderFormItemsSelector,
    getPartnerDiscountEnabledSelector,
    shouldShowThresholdBar,
    getFixedBasketFooterFeatureActive,
  ],
  (
    editBasketItemOutOfStockOverlayIds,
    editBasketItemRemoveOverlayIds,
    editBasketItemUpdateActiveIds,
    editBasketRemoveItemApiCallActiveIds,
    tradeInQuotes,
    isProcessing,
    items,
    partnerDiscountEnabled,
    thresholdBarEnabled,
    fixedBasketFooterEnabled,
  ) => ({
    editBasketItemOutOfStockOverlayIds,
    editBasketItemRemoveOverlayIds,
    editBasketItemUpdateActiveIds,
    editBasketRemoveItemApiCallActiveIds,
    tradeInQuotes,
    isProcessing,
    items,
    partnerDiscountEnabled,
    thresholdBarEnabled,
    fixedBasketFooterEnabled,
  }),
);

export default editBasketModalState;
